import styled from '@emotion/styled'

import { Icon } from '@/legacy/components/Icon'
import type { Icon as IconType } from '@/legacy/components/Icon/types'
import { ScreenReaderHidden } from '@/legacy/components/ScreenReaderHidden'
import { VisuallyHidden } from '@/legacy/components/VisuallyHidden'

const StarInputStyles = styled.div`
  display: flex;
  .star-icon {
    cursor: pointer;
    font-size: 1.875rem;
  }
`

export type StarInputProps = {
  item: { label: string; id: number }
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onMouseOver: (event: React.MouseEvent<HTMLDivElement>) => void
  checked: boolean
  onClick?: () => void
  itemOnHover: number
}

const StarInput = ({
  item,
  onChange,
  checked,
  onClick,
  itemOnHover,
  onMouseOver,
}: StarInputProps) => {
  const starId = `star-input-${item.id}`

  const icon: IconType = checked || itemOnHover >= item.id ? 'star' : 'ghost-star'

  return (
    <StarInputStyles onMouseOver={onMouseOver}>
      <label htmlFor={starId}>
        <VisuallyHidden>
          <input
            type="radio"
            className="star"
            name="star"
            id={starId}
            value={item.id}
            onChange={onChange}
            aria-label={item.label}
            onClick={onClick}
          />
        </VisuallyHidden>
        <ScreenReaderHidden>
          <Icon
            title={item.label}
            className="star-icon"
            icon={icon}
            height={100}
            width={100}
            color="accent"
          />
        </ScreenReaderHidden>
      </label>
    </StarInputStyles>
  )
}

export default StarInput
